/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../../constants';
const elementName = `${COMPONENT_NAME_PREFIX}radio-group`;
const observedAttributes = {
    DISABLED: 'disabled'
};
const attributes = {
    ...observedAttributes
};
export const RADIO_GROUP_CONSTANTS = {
    elementName,
    observedAttributes,
    attributes
};
